const ActivityTypes = {
  ShortAnswer: 1,
  FlashCard: 2,
  ConstructedResponse: 3,
  DBQ: 4,
  Assignment: 5,
  Documents: 99
};

export default ActivityTypes;